export default class ServicioNotificacionBalanceModel {
  image: string;
  title: string;
  cardTitle: null;
  description: string;
  terms: string;
}

export class UserBalanceModel {
  nombre_Usuario: string;
  email_Usuario: string;
  tipoBeneficio: string;
}
